import { render, staticRenderFns } from "./ObjectInOfferDetails.vue?vue&type=template&id=2e9e66fd&"
import script from "./ObjectInOfferDetails.vue?vue&type=script&lang=js&"
export * from "./ObjectInOfferDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports